import axios from "axios";
import { API_URL, WEB_URL } from "../../constants";

export const AdminMargin = async (id) => {
    const token = sessionStorage.getItem('LOGIN_TOKEN');

    try {
        let res = await axios.get(WEB_URL + "update_margin/"+id, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        });
    } catch (err) {
    }

}